import React from "react";
import {Breadcrumb, Icon} from "@fluentui/react";

import type IsaacBreadCrumbsProp from "./IsaacBreadCrumbsProp";
import useIsaacBreadCrumb from "./useIsaacBreadCrumb";

const IsaacBreadCrumb: React.FC<IsaacBreadCrumbsProp> = ({
  maxDisplayedItems,
  iconName,
}) => {
  const crumbs = useIsaacBreadCrumb();
  return (
    <>
      {crumbs && (
        <Breadcrumb
          dividerAs={() => <Icon iconName={iconName} />}
          items={crumbs}
          maxDisplayedItems={maxDisplayedItems}
        />
      )}
    </>
  );
};

export default IsaacBreadCrumb;
